/* eslint-disable camelcase */

export const defaultLevelObj = (placementIndex, begin_time_utc, end_time_utc) => {
  return {
    'id': 0,
    'temp_id': -1001,
    'name': 'New Ticket',
    'price':  0,
    'stock_quantity': ' ',
    'fee_setting': {
      'currency': 'USD',
      'transaction_percent': 0.029,
      'transacton_fix_fee': 30
    },
    'description': ' ',
    'expand_description': false,
    'is_need_code_to_show': false,
    'fee_type': 'ExcludeFee',
    'is_active': true,
    'merchant_fee': '0',
    'order_max_quantity': '10',
    'order_min_quantity': '0',
    'default_ticket_quantity': '0',
    'placement_index': placementIndex || 1,
    'is_set_sale_time': false,
    'specific_message': '',
    'tax_use_percentage': 0,
    'tax_percentage': '0',
    'tax': '0',
    'can_delete': true,
    'sale_begin_time_utc': begin_time_utc,
    'sale_end_time_utc': end_time_utc,
    'is_show_long_ticket_description': false,
    'is_show_ticket_description': false,
    'is_add_ticket_custom_confirmation': false,
    'is_customize_ticket_taxes_and_fees': false,
    'is_customize_ticket_quantity_options': false
  };
};
